// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__nt+IZ","moreInfo":"TopMenu_moreInfo__H4kTG","logo":"TopMenu_logo__gENbc","menuTrigger":"TopMenu_menuTrigger__lqTtD","closed":"TopMenu_closed__r5TSl"};